var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconExclamationMarkWarningBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F6C98E",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.6,
    stroke: "#F6C98E",
    strokeOpacity: 0.1,
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 7,
    y: 7,
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1333 12.2667L11.8 2.66667C11.0833 1.37501 10.0916 0.666672 8.99998 0.666672C7.90831 0.666672 6.91665 1.37501 6.19998 2.66667L0.866648 12.2667C0.191648 13.4917 0.116648 14.6667 0.658315 15.5917C1.19998 16.5167 2.26665 17.025 3.66665 17.025H14.3333C15.7333 17.025 16.8 16.5167 17.3416 15.5917C17.8833 14.6667 17.8083 13.4833 17.1333 12.2667ZM8.37498 6.50001C8.37498 6.15834 8.65831 5.87501 8.99998 5.87501C9.34165 5.87501 9.62498 6.15834 9.62498 6.50001V10.6667C9.62498 11.0083 9.34165 11.2917 8.99998 11.2917C8.65831 11.2917 8.37498 11.0083 8.37498 10.6667V6.50001ZM9.59165 13.7583C9.54998 13.7917 9.50832 13.825 9.46665 13.8583C9.41665 13.8917 9.36665 13.9167 9.31665 13.9333C9.26665 13.9583 9.21665 13.975 9.15831 13.9833C9.10831 13.9917 9.04998 14 8.99998 14C8.94998 14 8.89165 13.9917 8.83331 13.9833C8.78331 13.975 8.73331 13.9583 8.68331 13.9333C8.63331 13.9167 8.58331 13.8917 8.53331 13.8583C8.49165 13.825 8.44998 13.7917 8.40831 13.7583C8.25831 13.6 8.16665 13.3833 8.16665 13.1667C8.16665 12.95 8.25831 12.7333 8.40831 12.575C8.44998 12.5417 8.49165 12.5083 8.53331 12.475C8.58331 12.4417 8.63331 12.4167 8.68331 12.4C8.73331 12.375 8.78331 12.3583 8.83331 12.35C8.94165 12.325 9.05831 12.325 9.15831 12.35C9.21665 12.3583 9.26665 12.375 9.31665 12.4C9.36665 12.4167 9.41665 12.4417 9.46665 12.475C9.50832 12.5083 9.54998 12.5417 9.59165 12.575C9.74165 12.7333 9.83331 12.95 9.83331 13.1667C9.83331 13.3833 9.74165 13.6 9.59165 13.7583Z",
    fill: "#F6C98E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExclamationMarkWarningBig);
export default __webpack_public_path__ + "static/media/icon-exclamation-mark-warning-big.29d27f33f44d605bb84bcfbdefc488a1.svg";
export { ForwardRef as ReactComponent };